import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TextArea from "../../../Common/Forms/TextArea";
import Modal from "../../../Common/ModalGeneric";

import { postIleggelserForsinketMakulering as postIleggelserForsinketMakuleringAction } from "../../../../actions/ileggelseForsinketMakuleringerActions";
import {
    getIleggelse as getIleggelseAction,
    getIleggelseKlager as getIleggelseKlagerAction,
} from "../../../../actions/ileggelserActions";

import { required } from "../../../../utils/inputValidationUtils";

export default function ForsinketMakuleringContainer({ reloadHistorikk }) {
  const ileggelse = useSelector((state) => state.ileggelse);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [showSubmitSpinner, setShowSubmitSpinner] = useState(false);
  const [kommentar, setKommentar] = useState("");
  const [kommentarValidationText, setKommentarValidationText] = useState(null);

  const postIleggelserForsinketMakulering = (id, k) =>
    dispatch(postIleggelserForsinketMakuleringAction(id, k));
  const getIleggelse = (id) => dispatch(getIleggelseAction(id));
  const getIleggelseKlager = (id) => dispatch(getIleggelseKlagerAction(id));

  const isValid = () => {
    const validationText = required("Kommentar", kommentar);
    setKommentarValidationText(validationText);
    return !validationText;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "kommentar") setKommentar(value);
  };

  const handleApiCall = async (event) => {
    event.preventDefault();
    if (isValid()) {
      setShowSubmitSpinner(true);
      postIleggelserForsinketMakulering(ileggelse.id, kommentar)
        .then(() => {
          getIleggelse(ileggelse.id);
          getIleggelseKlager(ileggelse.id);
          reloadHistorikk();
          setOpen(false);
          setKommentarValidationText(null);
          setShowSubmitSpinner(false);
        })
        .catch(() => {
          setShowSubmitSpinner(false);
        });
    }
  };

  const showForsinketMakulering = () =>
    ileggelse &&
    ileggelse.forsinketMakuleringStatus &&
    ileggelse.forsinketMakuleringStatus.createPossible;

  if (showForsinketMakulering()) {
    return (
      <span style={{ marginLeft: 20 }}>
        <Modal
          id={ileggelse.id}
          modalTitle={`Forsinket makulering av ileggelse ${ileggelse.ileggelsesnummer}`}
          open={open}
          closeModal={() => {
            setOpen(false);
            setKommentarValidationText(null);
            setShowSubmitSpinner(false);
          }}
          openModal={() => setOpen(true)}
          popUpButtonText="Forsinket makulering"
          isButtonLink
          submit={handleApiCall}
          disabled={false}
          submitButtonText="Send vedtak"
          showSubmitSpinner={showSubmitSpinner}
          popUpButtonType="button"
        >
          <React.Fragment>
            <p>
              Vil du gjøre en forsinket makulering av ileggelse{" "}
              {ileggelse.ileggelsesnummer}?
            </p>
            <TextArea
              label="Forsinket makuleringsårsak"
              name="kommentar"
              onChange={handleChange}
              validationError={kommentarValidationText}
            />
          </React.Fragment>
        </Modal>
      </span>
    );
  }
  return <span />;
}

ForsinketMakuleringContainer.propTypes = {
  reloadHistorikk: PropTypes.func.isRequired,
};
